﻿
var mmsystem = mmsystem || {};
mmsystem.ui = mmsystem.ui || {};

//Node imports
//mmsystem.core = require('mmsystem-core');
mmsystem.ui.ajax = require('mmsystem-ui-ajax');
mmsystem.utilities = require('mmsystem-utilities');
var events = require('events');

//var $ = jQuery = mmsystem.core.$;

mmsystem.plugins = {

    EventEmitter: new events.EventEmitter(),

    ValidatorExtend: {

        Init: function (jQuery, validatorObject) {
            this.$ = jQuery;
            this.Validator = this.$.validator;
            this.ValidatorObject = validatorObject;
            //console.log("mmsystem.plugins.ValidatorExtend.Init ...");
        },

        CheckIsValueChanged: function (field, message) {
            //console.log("mmsystem.plugins.ValidatorExtend.DuplicateUrlError ...");
            
            var oldVal = field.val();
            var displayMessage = "Current value is not valid, please change it";
            if (message)
                displayMessage = message;

            this.Validator.addMethod("isOldValue", function (value, element, params) {
                return this.optional(element) || params != value;
            }, displayMessage);

            field.rules("add", {
                isOldValue: oldVal
            });
        },

        CheckNoSpace: function (field, message) {

            var fieldVal = field.val();
            var displayMessage = "No space please and don't leave it empty";
            if (message)
                displayMessage = message;

            this.Validator.addMethod("NoSpace", function (value, element) {
                return value.indexOf(" ") < 0 && value != "";
            }, displayMessage);


            field.rules("add", {
                NoSpace: true
            });
        },

        UseDecimalComma: function () {
            console.log("mmsystem.plugins.ValidatorExtend.DecimalComma ...");
            this.Validator.methods.range = function (value, element, param) {
                var globalizedValue = value.replace(",", ".");
                return this.optional(element) || (globalizedValue >= param[0] && globalizedValue <= param[1]);
            }

            this.Validator.methods.number = function (value, element) {
                return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:[\s\.,]\d{3})+)(?:[\.,]\d+)?$/.test(value);
            }

            var displayMessage = 'Please use "," for decimal places';
            this.Validator.addMethod("NoDecimalDots", function (value, element) {
                return value.indexOf(".") < 0;
            }, displayMessage);

        },

        CheckPrice: function () {
            this.UseDecimalComma();
            //console.log("mmsystem.plugins.ValidatorExtend.CheckPrice ...");
            var validator$ = this.$;
            var validatorObj = this.ValidatorObject;

            this.Validator.addClassRules("validate-price", {
                number: true,
                range: [0.01, 10000]
                //NoDecimalDots: true
            });

            this.Validator.addClassRules("validate-price-allow-zero", {
                number: true,
                range: [0, 10000]
                //NoDecimalDots: true
            });

            //this.Validator.messages.number = displayMessage;
            $('.use-exchange-rate').each(function () {
                checkExchangeValidationRules($(this), false);

                $(this).change(function () {
                    checkExchangeValidationRules($(this), true);
                });
            });

            function checkExchangeValidationRules(checkbox, validate){
                var priceInput = validator$("#price-value-" + checkbox.data('price-id'));
                var useExchange = checkbox.is(":checked");

                //console.log("checkExchangeValidationRules");
                //console.log("checkExchangeValidationRules");

                if (useExchange) {
                    //'checked' event code
                    priceInput.rules("add", {
                        required: false
                    });
                } else {
                    //'unchecked' event code
                    priceInput.rules("add", {
                        required: true
                    });
                }

                if (validate) {
                    // Validate
                    validatorObj.form();
                }
            };

            //$('.use-exchange-rate').change(function () {
            //    var priceInput = validator$("#price-value-" + $(this).data('price-id'));
                
            //    if ($(this).is(":checked")) {
            //        //'checked' event code

            //        priceInput.rules("add", {
            //            required: true
            //        });
            //    } else {
            //        //'unchecked' event code
            //        priceInput.rules("add", {
            //            required: false
            //        });
            //    }

            //    // Validate
            //    validatorObj.form();
            //});
        }
    },

    CurrencySwitcher: {

        Init: function (paramName) {
            //console.log("mmsystem.plugins.CurrencySwitcher.Init...");

            this.GetCurrencyElement().click(function () {
                var currency = $(this).data('currency');
                var url = window.location.href;
                if (url.indexOf('?') > -1) {
                    if (url.includes(paramName)) {
                        var index = url.indexOf(paramName) + paramName.length + 1; //extra for =
                        var iso = url.substring(index, index + 3);
                        url = url.replace(paramName + '=' + iso, paramName + '=' + currency);
                    } else {
                        url += '&' + paramName + '=' + currency;
                    }
                    
                } else {
                    url += '?' + paramName + '=' + currency;
                }
                window.location.href = url;
            });

            
        },

        GetCurrencyElement: function () {
            return $('.currency-swither-element');
        },

        GetCurrencyGobalElement: function () {
            return $('#global-currency-id');
        },

        GetGlobalCurrencyId: function () {
            return parseInt(this.GetCurrencyGobalElement().val(), 10);
        }

    },

    LanguageSwitcher: {

        Init: function (formId) {
            //console.log("mmsystem.plugins.LanguageSwitcher.Init...");
            var form = $('#' + formId);
            var input = this.GetLanguageInputElement();
            this.GetLanguageElement().click(function () {
                var language = $(this).data('language');
                input.val(language);
                //console.log('switch lang to: ' + language);
                form.submit();
            });


        },

        GetLanguageElement: function () {
            return $('.language-swither-element');
        },
        GetLanguageInputElement: function () {
            return $('input[name ="culture"]');
        }

    },

    HtmlComponents: {

        InputPlusMinus: {
            Init: function (container, emitEvent) {
                
                $(container).on('click', '.plus-minus-input .button-plus', function (e) {
                    mmsystem.plugins.HtmlComponents.InputPlusMinus.IncrementValue(e);
                    if (emitEvent)
                        mmsystem.plugins.HtmlComponents.InputPlusMinus.EmitCompleteEvent(e);
                });

                $(container).on('click', '.plus-minus-input .button-minus', function (e) {
                    mmsystem.plugins.HtmlComponents.InputPlusMinus.DecrementValue(e);
                    if (emitEvent)
                        mmsystem.plugins.HtmlComponents.InputPlusMinus.EmitCompleteEvent(e);
                });

            },

            IncrementValue: function(e) {
                e.preventDefault();
                var fieldName = $(e.target).data('field');
                var parent = $(e.target).closest('div');
                var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
                var maxVal = parseInt(parent.find('input[name=' + fieldName + ']').data('max'), 10);
                if (isNaN(maxVal))
                    maxVal = 0;

                if (!isNaN(currentVal)) {
                    if ((maxVal == 0 || currentVal < maxVal))
                        parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
                } else {
                    parent.find('input[name=' + fieldName + ']').val(0);
                }
            },

            DecrementValue: function(e) {
                e.preventDefault();
                var fieldName = $(e.target).data('field');
                var parent = $(e.target).closest('div');
                var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
                var minVal = parseInt(parent.find('input[name=' + fieldName + ']').data('min'), 10);
                if (isNaN(minVal))
                    minVal = 0;

                if (!isNaN(currentVal) && currentVal > 0) {
                    if (currentVal > minVal)
                        parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
                } else {
                    parent.find('input[name=' + fieldName + ']').val(0);
                }
            },

            EmitCompleteEvent: function (e) {
                // Add Event
                //console.log('Add "QtyModifierCalculateQuantityComplete" Event');
                //console.log(el);
                var el = $(e.target);
                mmsystem.plugins.Basket.EventEmitter.emit('QtyModifierCalculateQuantityComplete', el);
            }
        },

        QtyModifier: {
            Init: function (container, emitEvent) {
                if ($(container)) {
                    $(container).on('click', '.qty-btn', function (e) {
                        mmsystem.plugins.HtmlComponents.QtyModifier.CalculateQuantity(e, emitEvent);
                    });
                }
                //else {
                //    $('.qty-btn').on('click, .qty-btn', function (e) {
                //        mmsystem.plugins.HtmlComponents.QtyModifier.CalculateQuantity(e);
                //    });
                //}
            },

            CalculateQuantity: function (e, emitEvent) {
                //console.log('QtyModifier.CalculateQuantity');
                
                var el = $(e.target);
                
                if (el.parent('.qty-btn').length) {
                    el = el.parent('.qty-btn');
                }
                //console.log(el);
                var main = el.parent();
                //console.log('main: ');
                //console.log(main);
                var input = main.children('.plus-minus__value');
                var val = parseInt(input.val(), 10);
                //console.log('input: ');
                //console.log(input);
                var maxVal = parseInt(input.data('max'), 10);
                var minVal = parseInt(input.data('min'), 10);
                if (isNaN(maxVal))
                    maxVal = 0;
                //console.log('val: ' + val + 'max val: ' + maxVal);
                // increase/decrease qty
                if (el.hasClass('plus') && val < maxVal) { val++; }
                else if (el.hasClass('minus') && val > minVal) { val--; }

                input.val(val);

                // activate/deactivate product
                if (val > 0) { main.addClass('active'); }
                else { main.removeClass('active'); }

                // Add Event
                //console.log('Add "QtyModifierCalculateQuantityComplete" Event');
                if (emitEvent)
                    mmsystem.plugins.HtmlComponents.QtyModifier.EmitCompleteEvent(e)
                //mmsystem.plugins.EventEmitter.emit('QtyModifierCalculateQuantityComplete', el);
            },

            EmitCompleteEvent: function (e) {
                // Add Event
                //console.log('Add "QtyModifierCalculateQuantityComplete" Event');
                //console.log(el);
                var el = $(e.target);
                mmsystem.plugins.Basket.EventEmitter.emit('QtyModifierCalculateQuantityComplete', el);
            }

        },

        CloneValues: {
            Init: function (options) {
                this.Button = options.button;
                this.FromElement = options.fromElement;
                this.ToElement = options.toElement;
                this.UseCurrencyValues = options.useCurrencyValues;
                this.ValidationObject = options.validationObject;

                if (this.Button)
                    this.AddButtonCloneEvent(this.Button);
            },

            AddButtonCloneEvent: function (button) {
                var fromElement = this.FromElement;
                var toElement = this.ToElement;
                var useCurrencyValues = this.UseCurrencyValues;
                var validationObject = this.ValidationObject;
                var valid = true;

                $(button).on('click', function (e) {
                    console.log("mmsystem.plugins CloneValues.AddButtonCloneEvent...click");
                    e.preventDefault();
                    if (validationObject) {
                        valid = validationObject.valid();
                        console.log("valid: " + valid);
                    }

                    if (valid) {
                        if (useCurrencyValues)
                            mmsystem.plugins.HtmlComponents.CloneValues.CloneCurrencyValues(fromElement, toElement);
                        else
                            mmsystem.plugins.HtmlComponents.CloneValues.Clone(fromElement, toElement);
                    }
                    
                });
            },

            Clone: function (fromElement, toElement) {
                console.log("mmsystem.plugins CloneValues.Clone...");
                var value = $(fromElement).val();
                console.log("value: " + value);
                if ($(toElement))
                    $(toElement).val(value);
                
            },

            CloneCurrencyValues: function (fromElement, toElement) {
                console.log("mmsystem.plugins CloneValues.CloneCurrencyValues...");
                
                $(fromElement).each(function (index, element) {
                    var currencyId = $(this).data('currency-id');
                    var value = $(this).val();
                    var cloneTo = $(toElement + "[data-currency-id='" + currencyId + "']"); 
                    //console.log("value: " + value + "currencyId: " + currencyId);
                    //console.log(cloneTo);
                    cloneTo.val(value);
                });

            },
        }
    },

    Basket: {
        EventEmitter: new events.EventEmitter(),

        Init: function (order, options) {
            //console.log("mmsystem.plugins Basket.Init...");
            //console.log(options);
            this.Options = options;
            this.Order = order;

            //Admin----
            if (this.Options.template == "adminBigBasket") {
                //console.log("mmsystem.plugins adminBigBasket.Init...");
                this.Options.UpdateItemAPIUrl = "/Admin/Orders/APIEdit";
                this.Options.GetItemRowHtmlAPIUrl = "/Admin/Orders/APIBasketItemRawHtml";
                this.Options.CheckDiscountCodeAPIUrl = "/Admin/Orders/APICheckDiscountCode";
                this.Notification = mmsystem.plugins.Toast.Init(this.Options.notification);
                //this.Notification = this.Options.notification;
                mmsystem.plugins.HtmlComponents.InputPlusMinus.Init(this.GetBasketComponentByClass(), true);
            }
            else if (this.Options.template == "miniBasket") {
                this.Options.UpdateItemAPIUrl = "/Orders/APIEdit";
                this.Options.GetItemRowHtmlAPIUrl = "/Orders/APIBasketItemRawHtml";
                this.Options.CheckDiscountCodeAPIUrl = "/Orders/APICheckDiscountCode";
                this.Options.UpdateNoteAPIUrl = "/Orders/APINoteEdit";
                this.Notification = mmsystem.plugins.NotificationInterface;
                //mmsystem.plugins.HtmlComponents.InputPlusMinus.Init(this.GetProductListElement());
                mmsystem.plugins.HtmlComponents.QtyModifier.Init(this.GetBasketComponentById('header-basket'), true);
                mmsystem.plugins.HtmlComponents.QtyModifier.Init(this.GetBasketComponentById('big-basket'), true);
                mmsystem.plugins.HtmlComponents.QtyModifier.Init(this.GetProductListElement(), false);
            }

            //Toggle Elements
            this.ToggleElements();

            //Product Option changed
            this.AddBasketChangeOptionEvenListener();

            //Product Variety changed
            //this.AddBasketChangeVarietyEvenListener();
            
            //Remove Item from Basket
            this.AddBasketRemoveItemEventListener(mmsystem.plugins.Basket.Options.UpdateItemAPIUrl);

            //Add Item to Basket
            this.AddBasketAddItemEventListener(mmsystem.plugins.Basket.Options.UpdateItemAPIUrl);

            //Add Item Quantity change
            this.AddBasketQuantityItemEventListener(mmsystem.plugins.Basket.Options.UpdateItemAPIUrl);

            //Add Discount Code Check
            this.AddOrderApplyDiscountEventListener(mmsystem.plugins.Basket.Options.CheckDiscountCodeAPIUrl);

            //Add Note Save
            this.AddBasketSaveNoteEventListener(mmsystem.plugins.Basket.Options.UpdateNoteAPIUrl);

            //Ajax
            this.AddAjaxListeners();

            //Currency Switcher
            if (this.Options.useGlobalCurrency)
                this.CheckCurrencyChanged();

            //Update total
            this.UpdateSelectOptionsValues();

            //Add Complete Event
            
            mmsystem.plugins.Basket.EventEmitter.emit('BasketInitComplete', 'test'); 
            //console.log('EventEmitter emit "BasketInitComplete" ');
            //console.log(mmsystem.plugins.EventEmitter);
            
        },


        AddBasketChangeOptionEvenListener: function () {
            //custom select element (no change event)
            this.GetProductOptionsElements(true).click(function () {
                mmsystem.plugins.Basket.UpdateSelectOptions($(this));
            });
            //generic select element (change event)
            this.GetProductOptionsSelectElement().change(function () {
                console.log('select changed...');
                mmsystem.plugins.Basket.UpdateSelectOptions($("option:selected", this));
            });
        },

        AddBasketChangeVarietyEvenListener: function () {
            this.GetProductVarietiesElement().click(function () {
                console.log('variety changed...');
                mmsystem.plugins.Basket.UpdateProductVariety($(this));
            });
        },

        AddBasketQuantityItemEventListener: function (url) {
            mmsystem.plugins.Basket.EventEmitter.on('QtyModifierCalculateQuantityComplete', function (param) {
                console.log('QtyModifierCalculateQuantityComplete: ' + param);
                var row = param.closest('.basket-product-row');
                var productInfo = row.find('.product-info-data');
                var itemId = parseInt(productInfo.data('item-id'), 10);
                var productId = parseInt(productInfo.data('product-id'), 10);
                var currencyId = parseInt(productInfo.data('currency-id'), 10);
                var discountId = parseInt(productInfo.data('discount-id'), 10);
                var productOptionsIds = productInfo.data('product-options');
                var quantity = parseInt(row.find('input.quantity-field').val(), 10);
                //console.log('plus minus...');
                mmsystem.plugins.Basket.UpdateOrderItem(itemId, productId, quantity, currencyId, discountId, productOptionsIds, url);
            });

        },

        AddBasketRemoveItemEventListener: function (url) {
            this.GetBasketComponentByClass().on('click', '.remove-order-item', function (e) {
                e.preventDefault();
                var row = $(this).closest('.basket-product-row');
                var productInfo = row.find('.product-info-data');
                var itemId = parseInt(productInfo.data('item-id'), 10);
                var productId = parseInt(productInfo.data('product-id'), 10);
                var productOptionsIds = productInfo.data('product-options');
                var currencyId = parseInt(productInfo.data('currency-id'), 10);
                var discountId = parseInt(productInfo.data('discount-id'), 10);
                var quantity = 0;
                mmsystem.plugins.Basket.UpdateOrderItem(itemId, productId, quantity, currencyId, discountId, productOptionsIds, url);
            });
        },

        AddBasketAddItemEventListener: function (url) {
            this.GetBasketAddItemButtonByClass().click(function (e) {
                e.preventDefault();
                //Ajax cover
                //mmsystem.plugins.AjaxCover.ShowOnButton($(this).attr('id'))
                console.log('add to basket clicked...');
                var productId = parseInt($(this).data('product-id'), 10);
                var productOptionsIds = mmsystem.plugins.Basket.GetProductSelectedOptionsArray(productId);
                var currencyId = parseInt($(this).data('currency-id'), 10);
                var discountId = parseInt($(this).data('discount-id'), 10);
                var mainDiscountId = parseInt($(this).data('main-discount-id'), 10);
                var currentQuantity = mmsystem.plugins.Basket.GetItemQuantityByProductIdOptions(productId, productOptionsIds);
                var quantity = parseInt($('input#quantity-product-id-' + productId).val(), 10);
                console.log('product options: ' + productOptionsIds);
                console.log(productOptionsIds);
                console.log(productId + " " + currencyId + " " + quantity + " " + discountId);
                //Check if promocode Applied
                //if (mmsystem.plugins.Basket.Order.AppliedDiscountId > 0)
                //    discountId = mmsystem.plugins.Basket.Order.AppliedDiscountId
                //else
                //    discountId = mainDiscountId;
                discountId = mainDiscountId;

                mmsystem.plugins.Basket.UpdateOrderItem(0, productId, (quantity + currentQuantity), currencyId, discountId, productOptionsIds, url);
            });
        },

        AddOrderApplyDiscountEventListener: function (url) {
            $('.apply-discount-code').click(function (e) {
                e.preventDefault();
                //console.log('discount code clicked...');
                var code = mmsystem.plugins.Basket.GetDiscountCodeInputByClass().val();
                //Ajax
                mmsystem.ui.ajax.OrderCheckDiscountCode(url, code);
            });

            $('.remove-discount-code').click(function (e) {
                e.preventDefault();
                console.log('remove discount code clicked...');
                mmsystem.plugins.Basket.Order.AppliedDiscountId = 0;
                mmsystem.plugins.Basket.SetItemsMainDiscountId();
                
                //Ajax
                mmsystem.ui.ajax.OrderUpdateItem(mmsystem.plugins.Basket.Options.UpdateItemAPIUrl, mmsystem.plugins.Basket.Order);
            });
        },

        AddBasketSaveNoteEventListener: function (url) {
            $('.save-order-note').click(function (e) {
                e.preventDefault();
                //console.log('add note clicked...');
                var text = $('.add-order-note-widget .order-note-text').val();
                //console.log(text);
                mmsystem.plugins.Basket.SaveOrderNote(url, text);
            });
        },

        AddAjaxListeners: function () {
            //console.log('AddAjaxListeners...');
            //Add (orderUpdateComplete)listener
            mmsystem.ui.ajax.EventEmitter.on("orderUpdateComplete", function (param) {
                console.log("mmsystem.plugins.Basket ... on orderUpdateComplete");
                //console.log(param);
                var result = param.responseJSON; // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                //console.log(result);
                if (result && result.Type == 1) {
                    //console.log("show success");
                    if (result.Object && result.Object.Order) {
                        
                        mmsystem.plugins.Basket.Order = result.Object.Order;
                        mmsystem.plugins.Basket.UpdateBasketValues();
                    }
                    mmsystem.plugins.Basket.Notification.Show('success', "Saved", result.Message);
                } else {
                    //console.log("show error");
                    if (result)
                        mmsystem.plugins.Basket.Notification.Show('error', "Not Saved", result.Message);
                    else
                        mmsystem.plugins.Basket.Notification.Show('error', "Not Saved", "Server error");
                }

                //Hide Ajax cover
                mmsystem.plugins.AjaxCover.Hide();

            });

            //Add (orderUpdateComplete)listener
            mmsystem.ui.ajax.EventEmitter.on("orderGetItemHtmlRow", function (param) {
                var result = param.responseJSON; // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                if (result && result.Type == 1) {
                    //console.log("show success");
                    if (result.Object && result.Object.RawHtml) {
                        mmsystem.plugins.Basket.AddBasketItemRow(result.Object.RawHtml, false);
                    }
                }
                //console.log(param.responseJSON);
            });

            //Add (orderCheckDiscountCodeComplete)listener
            mmsystem.ui.ajax.EventEmitter.on("orderCheckDiscountCodeComplete", function (param) {
                //console.log(param);
                var result = param.responseJSON; // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                if (result && result.Type == 1) {
                    //console.log("show success");
                    if (result.Object && result.Object.Discount) {
                        mmsystem.plugins.Basket.Order.AppliedDiscountId = result.Object.Discount.Id;
                        mmsystem.plugins.Basket.GetErrorInfoByClass().hide();

                        //Ajax
                        mmsystem.ui.ajax.OrderUpdateItem(mmsystem.plugins.Basket.Options.UpdateItemAPIUrl, mmsystem.plugins.Basket.Order);
                        //console.log(result.Object);
                    } else {
                        mmsystem.plugins.Basket.GetErrorInfoByClass().show();
                    }
                }
            });

            //Add (orderUpdateNoteComplete)listener
            $(mmsystem.ui.ajax).on("orderUpdateNoteComplete", function (e, param) {
                var result = param.responseJSON; // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                if (result && result.Type == 1) {
                    //console.log("show success");
                    if (result.Object && result.Object.Note) {
                        mmsystem.plugins.Basket.Order.Note = result.Object.Note;
                    }
                }
                mmsystem.plugins.Basket.UpdateOrderNoteWidget();
                //console.log(param.responseJSON);
            });
        },

        GetOrderItembyId: function (id) {
            var item = this.Order.Items.filter(function (val) {
                return val.Id === id;
            });

            return item;
        },

        GetOrderItembyProductId: function (productId) {
            var item = this.Order.Items.filter(function (val) {
                return val.ProductId === productId;
            });

            return item;
        },

        GetOrderItembyProductIdOptions: function (productId, productOptionsIds) {
            var item = this.Order.Items.filter(function (val) {
    
                return val.ProductId === productId && mmsystem.utilities.ArraysEqual(mmsystem.plugins.Basket.GetItemProductOptionsIdsArray(val.ProductOptions), productOptionsIds);

            });

            return item;
        },

        GetTotalItems: function () {
            var quantity = 0;
            var order = this.Order;
            if (order.Items && (order.Items.length > 0)) {
                $.each(order.Items, function (index, value) {
                    var item = order.Items[index];
                    quantity += item.Quantity;
                });

            }
            return quantity;
        },

        SetItemDiscountId: function (itemId, discountId) {
            var item = this.GetOrderItembyId(itemId);
            if (item[0])
                item[0].DiscountId = parseInt(discountId, 10);
            
        },

        SetItemsMainDiscountId: function () {

            var order = this.Order;
            if (order.Items && (order.Items.length > 0)) {
                $.each(order.Items, function (index, value) {
                    var item = order.Items[index];
                    item.DiscountId = item.Product.MainDiscountId;
                });

            }
        },

        SetItemsCurrencyId: function (currencyId) {

            var order = this.Order;
            if (order.Items && (order.Items.length > 0)) {
                $.each(order.Items, function (index, value) {
                    var item = order.Items[index];
                    item.CurrencyId = currencyId;
                });

            }
        },

        GetItemsInCurrencyId: function (currencyId) {

            var item = this.Order.Items.filter(function (val) {
                return val.CurrencyId === currencyId;
            });

            return item;
        },

        GetItemsNotInCurrencyId: function (currencyId) {

            var item = this.Order.Items.filter(function (val) {
                return val.CurrencyId !== currencyId;
            });

            return item;
        },

        AnyItemNotInCurrencyId: function (currencyId) {
            var item = this.GetItemsNotInCurrencyId(currencyId);
            if (item[0])
                return true;

            return false;
        },

        GetItemQuantityById: function (id) {
            var item = this.GetOrderItembyId(id);
            var quantity = 0;
            if (item[0])
                quantity = parseInt(item[0].Quantity, 10);

            return quantity;
        },

        GetItemQuantityByProductIdOptions: function (productId, productOptionsIds) {
            var item = this.GetOrderItembyProductIdOptions(productId, productOptionsIds);
            var quantity = 0;
            if (item[0])
                quantity = parseInt(item[0].Quantity, 10);

            return quantity;
        },

        GetItemProductOptionsIdsArray: function (productOptionsObj) {
            var orderItemOptionsIdsArray = [];
            if(productOptionsObj) {
                $.each(productOptionsObj, function (index, value) {
                    orderItemOptionsIdsArray.push(value.Id);
                });
            }
            return orderItemOptionsIdsArray;
        },

        CreateItemProductOptionsObject: function (productOptionsIds) {
            var array = [];
            
            $.each(productOptionsIds, function (index, value) {
                array.push({ Id: value });
            });

            return array
        },

        UpdateOrderItem: function (id, productId, quantity, currencyId, discountId, productOptionsIds, url) {
            console.log('UpdateOrderItem ...');
            var item = this.GetOrderItembyId(id);
            console.log(item);
            if (item[0]) {
                console.log('UpdateOrderItem: Found by id');
                console.log('UpdateOrderItem: quantity before update: ' + item[0].Quantity);
                item[0].Quantity = quantity;
                item[0].CurrencyId = currencyId;
                item[0].DiscountId = discountId;
                console.log('UpdateOrderItem: quantity after update: ' + item[0].Quantity);
            } else {
                console.log('UpdateOrderItem: not found by Id');
                //Check if productId and the same Options
                item = this.GetOrderItembyProductIdOptions(productId, productOptionsIds);
                if (item[0]) {
                    console.log('UpdateOrderItem: Found by options');
                    console.log('UpdateOrderItem: quantity before update: ' + item[0].Quantity);
                    item[0].Quantity = quantity;
                    item[0].CurrencyId = currencyId;
                    item[0].DiscountId = discountId;
                    console.log('UpdateOrderItem: quantity after update: ' + item[0].Quantity);
                } else {
                    console.log('UpdateOrderItem: not found by options - data: currencyId: ' + currencyId + ' discountId: ' + discountId);
                    this.Order.Items.push({ ProductId: productId, Quantity: quantity, CurrencyId: currencyId, DiscountId: discountId, ProductOptions: this.CreateItemProductOptionsObject(productOptionsIds) });
                }
                
            }

            //Check Global Currency
            if (this.Options.useGlobalCurrency) {
                this.SetItemsCurrencyId(mmsystem.plugins.CurrencySwitcher.GetGlobalCurrencyId());
            }
            //Ajax
            mmsystem.plugins.AjaxCover.ShowOnElement('small-basket');
            mmsystem.plugins.AjaxCover.ShowOnElement('big-basket');
            mmsystem.ui.ajax.OrderUpdateItem(url, mmsystem.plugins.Basket.Order);
            //HMR test 4
            return item;
        },

        SaveOrderNote: function (url, text) {
            mmsystem.plugins.Basket.Order.Note = text;
            //Ajax
            mmsystem.ui.ajax.OrderUpdateNote(url, mmsystem.plugins.Basket.Order);
        },

        //CheckDiscountCode: function (url, code) {
        //    //Ajax
        //    mmsystem.ui.ajax.OrderCheckDiscountCode(url, code);
        //},

        //UpdateBasketItemsDiscounts: function () {
        //    console.log('mmsystem.plugins Basket.SetBasketItemsMainDiscounts');
        //    var order = this.Order;
        //    $.each(order.Items, function (index, value) {
        //        var item = order.Items[index];
        //        mmsystem.plugins.Basket.UpdateBasketComponentsItem(item);
        //    });
        //},

        UpdateBasketValues: function () {
            console.log('mmsystem.plugins Basket.UpdateBasketValues');
            var order = this.Order;
            console.log(order);
            //Reset all values to zero
            var basketRows = mmsystem.plugins.Basket.GetBasketItemAllRows();
            basketRows.find('input.quantity-field').val(0);

            if (order.Items && (order.Items.length > 0)) {
                //Add or update rows
                $.each(order.Items, function (index, value) {
                    var item = order.Items[index];
                    mmsystem.plugins.Basket.UpdateBasketComponentsItem(item);
                });

            }
            else {
                this.GetBasketExpandableComponentByClass().find('.basket-product-row-container').html('');
                //Check if reload
                if ($('body').hasClass('check-basket-items'))
                    location.reload();
            }

            //Update Basket Widget
            this.GetBasketWidgetComponent().find('.basket-qty').html(this.GetTotalItems());
            
            //Update Total
            this.GetBasketTotalRow().find('.order-total-price-value-string').html(order.PriceTotalString); // Basket with discounts & Applied discount & with Delivery
            this.GetBasketTotalRow().find('.order-items-price-value-string').html(order.ItemsPriceString); // Basket with discounts & no Applied discount & no Delivery
            this.GetBasketTotalRow().find('.order-price-value-string').html(order.PriceString); // Basket with discounts & Applied discount & no Delivery
            this.GetBasketTotalRow().find('.order-no-discount-price-value-string').find('del').html(order.PriceNoDiscountsString); // Basket no discounts & no Applied discount & no Delivery
            this.GetBasketTotalRow().find('.discount-items-applied-total-value-string').html('-' + order.ItemsDiscountString); // Items discounts total
            //Update Applied Discount
            mmsystem.plugins.Basket.UpdateDiscountApplyWidget();
            //Update Delivery
            if (order.Delivery && order.Delivery.PriceString && order.Delivery.Name) {
                this.GetBasketComponentByClass().find('.order-delivery-price-value-string').html(order.Delivery.PriceString);
                this.GetBasketComponentByClass().find('.shipping-msg').html(order.Delivery.Name);
            }
            

            //Toggle Elements
            this.ToggleElements();
            
        },

        CheckCurrencyChanged: function () {
            console.log('CheckCurrencyChanged...: ');
            
            var currencyId = mmsystem.plugins.CurrencySwitcher.GetGlobalCurrencyId();
            //console.log('currencyId: ' + currencyId);
            //console.log('before: ');
            //console.log(this.Order);
            //console.log('AnyItemNotInCurrencyId: ' + this.AnyItemNotInCurrencyId(currencyId));
            if (this.AnyItemNotInCurrencyId(currencyId)) {
                //console.log('Update items to currency Id: ' + currencyId);
                this.SetItemsCurrencyId(currencyId);
                //Ajax
                mmsystem.ui.ajax.OrderUpdateItem(mmsystem.plugins.Basket.Options.UpdateItemAPIUrl, mmsystem.plugins.Basket.Order);
            }
            
        },

        UpdateBasketComponentsItem: function (item) {
            //console.log('UpdateBasketComponentsItem...');
            var baskets = mmsystem.plugins.Basket.GetBasketComponentByClass();
            baskets.each(function () {
                var componentId = $(this).attr('id');
                var IsBasketExpandable = $(this).hasClass('basket-expandable');
                var template = $(this).data('basket-template');
                var row = mmsystem.plugins.Basket.GetBasketComponentIdItemRow(componentId, item.Id);
                //if row exist
                if (row.length) {
                    //console.log('basket row exist update...');
                    row.find('.order-item-price-value-string').html(item.PriceString);
                    row.find('.order-item-total-price-value-string').html(item.PriceTotalString);
                    row.find('.order-item-no-discount-price-string').find('del').html(item.PriceNoDiscountsString);
                    row.find('.order-item-no-discount-price-total-string').find('del').html(item.PriceTotalNoDiscountsString);
                    if (row.find('input.quantity-field').val() != item.Quantity) {
                        row.find('span.quantity-field').html(item.Quantity);
                        row.find('input.quantity-field').val(item.Quantity);
                    }
                }
                else {
                    //console.log('basket row not exist add...');
                    if (IsBasketExpandable) {
                        mmsystem.plugins.Basket.GetBasketItemRawHtml(item.Id, mmsystem.plugins.Basket.Options.GetItemRowHtmlAPIUrl, template);
                    }
                        
                }

                //Remove html rows
                mmsystem.plugins.Basket.GetBasketComponentIdItemAllRows(componentId).each(function () {
                    
                    var productInfo = $(this).find('.product-info-data');
                    var itemId = parseInt(productInfo.data('item-id'), 10);
                    var productId = parseInt(productInfo.data('product-id'), 10);
                    var item = mmsystem.plugins.Basket.GetOrderItembyId(itemId);

                    //console.log('row: ' + $(this).attr('class') + ' IsBasketExpandable: ' + IsBasketExpandable);
                    if (!item[0] && IsBasketExpandable) {
                        mmsystem.plugins.Basket.RemoveBasketComponentIdItemRow(componentId, itemId);
                    }
                });

            });
        },

        ToggleElements: function () {
            //console.log('ToggleElements - Order Total: ' + this.Order.PriceTotal);
            if (this.Order.PriceTotal > 0) {
                this.GetBasketComponentById('basket').removeClass('empty');
                this.GetCheckoutBtn().addClass('active');
                this.GetElementsToHideWhenEmpty().show();
                this.GetElementsToShowWhenEmpty().hide();
            } else {
                this.GetBasketComponentById('basket').addClass('empty');
                this.GetCheckoutBtn().removeClass('active');
                this.GetElementsToHideWhenEmpty().hide();
                this.GetElementsToShowWhenEmpty().show();
            }

            //Discounts
            this.ToggleDiscounts();
            // Order Note
            this.UpdateOrderNoteWidget();
        },

        ToggleDiscounts: function () {
            var order = this.Order;
            if (order.Items && (order.Items.length > 0)) {
                $.each(order.Items, function (index, value) {
                    var item = order.Items[index];
                    if (item.Discount > 0)
                        mmsystem.plugins.Basket.ShowItemDiscounts(item.Id);
                    else
                        mmsystem.plugins.Basket.HideItemDiscounts(item.Id);
                });

            }
            
            if (this.Order.ItemsDiscount > 0)
                this.GetBasketOffersComponentByClass().show();
            else
                this.GetBasketOffersComponentByClass().hide();

            if (this.Order.Discount > 0)
                this.GetDiscountTotalElementByClass().show();
            else
                this.GetDiscountTotalElementByClass().hide();

        },

        UpdateProductVariety: function (el) {
            //console.log(el);
            var addToBasketProductInfoButton = this.GetBasketAddItemButtonByClass();
            var productId = parseInt(el.data('product-id'), 10);
            //console.log(productId);
            addToBasketProductInfoButton.data('product-id', productId);
            //console.log('new product id: ' + addToBasketProductInfoButton.data('product-id'));
        },

        UpdateSelectOptions: function (el) {
            console.log('UpdateSelectOptions...');
            var isMain = el.hasClass('main');
            var typeId = el.data('option-type-id');
            var optionId = el.data('value');
            console.log('option changed: isMain - ' + isMain + ', optionId: ' + optionId);
            var imageId = el.data('image-id');
            //console.log(el);
            $('.thumbnail[data-image-id="' + imageId + '"]').click();
            mmsystem.plugins.Basket.GetProductOptionsElementsByTypeId(typeId).removeClass('selected-option');
            el.addClass('selected-option');
            if (isMain) {
                mmsystem.plugins.Basket.GetProductOptionsElements(false).addClass('d-none').removeClass('selected-option');
                mmsystem.plugins.Basket.GetProductOptionsElementsByParentId(optionId).removeClass('d-none');
                //reset to defaults
                mmsystem.plugins.Basket.GetProductOptionsElementsByParentId(optionId).each(function () {
                    var childOptionId = $(this).data('value');
                    var childIsDefault = $(this).hasClass('default-option');
                    var childParentId = $(this).data('parent-id');
                    //console.log('childOptionId: ' + childOptionId + ' childIsDefault: ' + childIsDefault + ' childParentId: ' + childParentId);
                    if (childIsDefault && (childParentId === optionId)) {
                        //console.log('selected-option: ' + childOptionId);
                        $(this).addClass('selected-option');
                        mmsystem.plugins.Basket.UpdateSelectOptionsData($(this));
                    }
                });
            }

            //Update total
            mmsystem.plugins.Basket.UpdateSelectOptionsValues();
        },

        UpdateSelectOptionsData: function (el) {
            //console.log('UpdateSelectOptionsData...');
            var slt = el.closest('.select');

            if (el.hasClass('option')) {
                var txt = el.text(),
                dataVal = el.attr('data-value');
                slt.find('.title').attr('data-value', dataVal);
                slt.find('.title').attr('data-image-id', el.attr('data-image-id'));
                slt.find('.title__text').text(txt);

                //console.log(txt, dataVal);
            }
        },

        UpdateSelectOptionsValues: function () {
            var totalElement = $('.add-to-cart .total-cost');
            var total = parseFloat(totalElement.data('product-base-price'));
            var currency = totalElement.data('product-base-price-currency')
            //console.log('Update Select Value: total: ' + total);
            this.GetProductOptionsElements(true).each(function () {
                var price = parseFloat($(this).data('price'));
                //console.log('price: ' + price);
                if ($(this).hasClass('selected-option'))
                    total += price;
            });
            //console.log('Update Select Value: total: ' + total.toFixed(2));
            totalElement.text(mmsystem.utilities.DisplayPrice(total, currency));
        },

        UpdateOrderNoteWidget: function () {
            //console.log('UpdateOrderNoteWidget...');
            var addNoteWidget = $('.add-order-note-widget');
            var textArea = addNoteWidget.find('.order-note-text');
            var button = this.GetBasketAddNoteBtn();
            if (mmsystem.plugins.Basket.Order.Note) {
                button.html('Edit Note');
                textArea.val(mmsystem.plugins.Basket.Order.Note);
                
            } else {
                button.html('Add Note');
            }
        },

        UpdateDiscountApplyWidget: function () {
            //console.log('UpdateOrderNoteWidget...');
            
            if (mmsystem.plugins.Basket.Order.AppliedDiscountId > 0) {
                mmsystem.plugins.Basket.GetDiscountApplyComponentByClass().addClass('d-none');
                mmsystem.plugins.Basket.GetDiscountRemoveComponentByClass().removeClass('d-none');
                mmsystem.plugins.Basket.GetDiscountCodePlacementByClass().text(mmsystem.plugins.Basket.Order.AppliedDiscountCode);

            } else {
                mmsystem.plugins.Basket.GetDiscountApplyComponentByClass().removeClass('d-none');
                mmsystem.plugins.Basket.GetDiscountRemoveComponentByClass().addClass('d-none');
                mmsystem.plugins.Basket.GetDiscountCodePlacementByClass().text('');
            }

            mmsystem.plugins.Basket.GetDiscountApplyTotalRow().html('- ' + mmsystem.plugins.Basket.Order.AppliedDiscountString);
        },

        AddBasketItemRow: function (rawHtml, showCategory) {
            var productInfo = $(rawHtml).find('.product-info-data');
            //console.log('add item to basket....');
            var itemId = parseInt(productInfo.data('item-id'), 10);
            var categoryId = parseInt(productInfo.data('category-id'), 10);
            var categoryName = productInfo.data('category-name');
            //console.log('categoryId: ' + categoryId);
            //console.log('categoryName: ' + categoryName);
            if (showCategory && categoryId) {
                var categoryItemElements = this.GetBasketExpandableComponentByClass().find('.basket-product-row-container .product-info-data[data-category-id="' + categoryId + '"]');
                //console.log('categoryItemElements: ');
                //console.log(categoryItemElements);
                if (categoryItemElements.length) {
                    categoryItemElements.closest('.basket-product-row-container').append(rawHtml);
                } else {
                    this.GetBasketExpandableComponentByClass().find('.basket-product-row-container').append('<h5 class="basket-product-category">' + categoryName + '</h5>');
                    this.GetBasketExpandableComponentByClass().find('.basket-product-row-container').append(rawHtml);
                }
            } else {
                this.GetBasketExpandableComponentByClass().find('.basket-product-row-container').append(rawHtml);
            }

            this.ToggleDiscounts();
        },
        HideItemDiscounts: function (itemId) {
            this.GetDiscountElementsByItemId(itemId).hide();
            this.GetDiscountTotalElementsByItemId(itemId).hide();
        },
        ShowItemDiscounts: function (itemId) {
            this.GetDiscountElementsByItemId(itemId).show();
            this.GetDiscountTotalElementsByItemId(itemId).show();
        },
        RemoveBasketItemRow: function (itemId) {
            this.GetBasketItemRow(itemId).remove();
        },
        RemoveBasketComponentIdItemRow: function (componentId, itemId) {
            var productInfo = this.GetBasketProductInfoData(itemId);
            var categoryId = parseInt(productInfo.data('category-id'), 10);
            var itemRow = this.GetBasketComponentIdItemRow(componentId, itemId);
            var categoryNameElement = itemRow.prev('.basket-product-category');
            itemRow.remove();
            //Remove Category Name element
            var categoryItemElements = this.GetBasketComponentIdItemRowsInCategory(componentId, categoryId);
            if (categoryItemElements.length == 0) {
                categoryNameElement.remove();
            }
        },
        GetProductListElement: function () {
            return $('#product-list');
        },
        GetBasketAddItemButtonByClass: function () {
            return this.GetProductListElement().find('.add-order-item');
        },
        GetBasketAddItemQuantityByClass: function () {
            return this.GetProductListElement().find('.add-order-item-quantity');
        },
        GetBasketProductInfoData: function (itemId) {
            return this.GetBasketItemRow(itemId).find('.product-info-data');
        },
        GetBasketExpandableComponentByClass: function () {
            return $('.basket-component.basket-expandable');
        },
        GetBasketComponentByClass: function () {
            return $('.basket-component');
        },
        GetBasketComponentById: function (id) {
            return $('#' + id);
        },
        GetBasketWidgetComponent: function () {
            return $('.basket-widget-component');
        },
        GetErrorInfoByClass: function () {
            return $('.error-msg');
        },
        GetDiscountApplyTotalRow: function () {
            return $('.discount-code-applied-value-string');
        },
        GetDiscountCodeInputByClass: function () {
            return $('.discount-code');
        },
        GetDiscountCodePlacementByClass: function () {
            return $('.discount-code-applied');
        },
        GetDiscountApplyComponentByClass: function () {
            return $('.discount-not-active');
        },
        GetDiscountRemoveComponentByClass: function () {
            return $('.discount-active');
        },
        GetDiscountElementsByItemId: function (itemId) {
            return this.GetBasketItemRow(itemId).find('.order-item-no-discount-price-string');
        },
        GetDiscountTotalElementsByItemId: function (itemId) {
            return this.GetBasketItemRow(itemId).find('.order-item-no-discount-price-total-string');
        },
        GetDiscountTotalElementByClass: function (itemId) {
            return this.GetBasketComponentByClass().find('.order-no-discount-price-value-string');
        },
        GetBasketAddNoteBtn: function () {
            return this.GetBasketComponentByClass().find('.order-add-note-btn');
        },
        GetBasketOffersComponentByClass: function () {
            return this.GetBasketComponentByClass().find('.offers-container');
        },
        GetCheckoutBtn: function () {
            return this.GetBasketComponentByClass().find('.checkout-btn');
        },
        GetElementsToHideWhenEmpty: function () {
            return this.GetBasketComponentByClass().find('.hide-order-empty');
        },
        GetElementsToShowWhenEmpty: function () {
            return this.GetBasketComponentByClass().find('.show-order-empty');
        },
        GetBasketComponentIdItemRowsInCategory: function (componentId, categoryId) {
            return this.GetBasketComponentById(componentId).find('.basket-product-row-container').find('.product-info-data[data-category-id="' + categoryId + '"]');
        },
        GetBasketItemRow: function (itemId) {
            return this.GetBasketComponentByClass().find('.basket-product-row-container').find('.basket-item-row-' + itemId);
        },
        GetBasketItemRowByProductId: function (productId) {
            return this.GetBasketComponentByClass().find('.basket-product-row-container').find('.basket-product-row-' + productId);
        },
        GetBasketComponentIdItemRow: function (componentId, itemId) {
            return this.GetBasketComponentById(componentId).find('.basket-product-row-container').find('.basket-item-row-' + itemId);
        },
        GetBasketComponentIdItemRowByProductId: function (componentId, productId) {
            return this.GetBasketComponentById(componentId).find('.basket-product-row-container').find('.basket-product-row-' + productId);
        },
        GetBasketItemAllRows: function () {
            return this.GetBasketComponentByClass().find('.basket-product-row');
        },
        GetBasketComponentIdItemAllRows: function (componentId) {
            return this.GetBasketComponentById(componentId).find('.basket-product-row');
        },
        GetBasketTotalRow: function () {
            return this.GetBasketComponentByClass().find('.basket-total-row');
        },
        GetBasketItemRawHtml: function (itemId, url, template) {
            //Ajax
            mmsystem.ui.ajax.OrderGetItemHtmlRow(url, { orderId: this.Order.Id, itemId: itemId, template: template });
        },
        GetProductSelectedOptionsArray: function (productId) {
            console.log('GetProductSelectedOptionsArray...');
            var selectedProductOptions = this.GetProductSelectedOptionsElements(productId);
            //console.log(selectedProductOptions);
            if (selectedProductOptions.length == 0) {
                selectedProductOptions = this.GetProductDefaultOptionsElements(productId);
            }

            console.log(selectedProductOptions);

            var array = [];
            selectedProductOptions.each(function (index) {
                //console.log(index + ": " + $(this).text());
                array.push($(this).data('value'));
            });

            return array;
        },
        GetProductVarietiesElement: function () {
            return $('.product-variety');
        },
        GetProductOptionsSelectElement: function () {
            return $('.product-options-select');
        },
        GetProductOptionsElements: function (includeMain) {
            if (includeMain)
                return $('.product-options-select .option');
            else
                return $('.product-options-select .option').not('.main');
        },
        GetProductDefaultsOptionsElements: function (includeMain) {
            if (includeMain)
                return $('.product-options-select .option.default-option');
            else
                return $('.product-options-select .option.default-option').not('.main');
        },
        GetProductOptionsElementsByTypeId: function (typeId) {
            return $('.product-options-select .option[data-option-type-id="' + typeId + '"]');
        },
        GetProductOptionsElementsByParentId: function (parentId) {
            return $('.product-options-select .option[data-parent-id="' + parentId + '"]');
        },
        GetProductSelectedOptionsElements: function (productId) {
            console.log('GetProductSelectedOptionsElements... productId: ' + productId);
            if (productId)
                return $('#product-option-select-id-' + productId + ' .option.selected-option');
            else
                return $('.product-options-select .option.selected-option');
        },
        GetProductDefaultOptionsElements: function (productId) {
            console.log('GetProductSelectedOptionsElements... productId: ' + productId);
            if (productId)
                return $('#product-option-select-id-' + productId + ' .default-option');
            else
                return $('.product-options-select .default-option');
        }
    },

    NotificationInterface: {
        Show: function (result, headerText, bodyText) {
            return;
        }
    },

    Toast: {

        Init: function (object) {
            //console.log("mmsystem.plugins.Toast.Init...");
            this.ToastObject = object;

            this.Container = $('.toast-container');
            this.Header = this.ToastObject.find('.toast-header');
            this.Body = this.ToastObject.find('.toast-body');

            return this;
        },

        Show: function (result, headerText, bodyText) {
            //console.log("mmsystem.plugins.Toast.Show...");
            this.Header.find('.toast-header-text').html(headerText);
            this.Header.addClass(this.Header.hasClass('text-' + result) ? '' : 'text-' + result);
            this.Body.html(bodyText);
            this.Body.addClass(this.Body.hasClass('alert-' + result) ? '' : 'alert-' + result);
            this.ToastObject.toast('show');
        }
    },

    Pagination: {
        Init: function (settings) {
            this.Settings = {};
            if (settings) {
                this.Settings = settings;
                if (settings.GetPageListHtmlAPIUrl)
                    this.Settings.GetPageListHtmlAPIUrl = settings.GetPageListHtmlAPIUrl;
                if (settings.GetPageCallbackFunction)
                    this.Settings.GetPageCallbackFunction = settings.GetPageCallbackFunction;
            }

            //Page changed
            this.AddEvenListeners();
        },

        AddEvenListeners: function () {
            this.GetPaginationItemLinks().on('click', function (e) {
                e.preventDefault();
                var pageIndex = $(this).data('page-index');
                var resultsPerPage = $(this).closest('.pagination').data('page-results');
                console.log('index: ' + pageIndex + ' results: ' + resultsPerPage);
                var data = { ResultsPerPage: resultsPerPage, CurrentPageIndex: pageIndex, UpdateCookie: true };
                if (mmsystem.plugins.Pagination.Settings.GetPageCallbackFunction)
                    mmsystem.plugins.Pagination.Settings.GetPageCallbackFunction(data);
                //mmsystem.plugins.AjaxCover.ShowOnElement('productsSelection');
                //mmsystem.ui.ajax.GetProductList(mmsystem.plugins.ProductFilter.Settings.GetProductListHtmlAPIUrl, data);
            });
        },

        GetPaginationElement: function () {
            return $('.pagination');
        },
        GetPaginationItems: function () {
            return this.GetPaginationElement().find('.page-item');
        },
        GetPaginationItemLinks: function () {
            return this.GetPaginationItems().find('.page-link');
        }
    },

    ProductFilter: {
        Id: 0,
        SelectedCategoriesArray: [],
        PriceOrder: '',
        Init: function (settings) {
            console.log("mmsystem.plugins.ProductFilter.Init...");
            this.Settings = {};
            if (settings) {
                this.Settings = settings;
                if (settings.SelectedCategoriesArray)
                    this.SelectedCategoriesArray = settings.SelectedCategoriesArray;
                if (settings.Id)
                    this.Id = settings.Id;
                if (settings.Id)
                    this.ProductTypeId = settings.ProductTypeId;
            }

            this.Settings.GetProductListHtmlAPIUrl = "/Products/APIGetProductListHtml";

            //Product Filter changed
            this.AddChangeCategoryEvenListener();
            this.AddChangeSortPriceEvenListener();

            //Ajax
            this.AddAjaxListeners();

            //Get Results
            this.GetFilteredProductList({ UseCookie: true, UpdateCookie: true });
        },

        AddChangeCategoryEvenListener: function () {
            this.GetCategorySelectElements().on('click', function () {
                mmsystem.plugins.ProductFilter.CheckIfRadioSingleOption($(this));
                mmsystem.plugins.ProductFilter.GetFilteredProductList({ UpdateCookie: true, CurrentPageIndex: 0 });
            });
        },

        AddChangeSortPriceEvenListener: function () {
            this.GetPriceSortSelectElements().on('click', function () {
                mmsystem.plugins.ProductFilter.GetFilteredProductList({ UpdateCookie: true, CurrentPageIndex: 0 });
            });
        },

        AddAjaxListeners: function () {

            mmsystem.ui.ajax.EventEmitter.on('getProductListComplete', function (param) {
                console.log('mmsystem.ui.ajax.EventEmitter: getProductListComplete');
                var result = param; // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                console.log(param);
                if (result && result.Type == 1) {
                    //console.log("show success");
                    if (result.Object && result.Object.RawHtml) {
                        //mmsystem.ui.content.orders.DomElements.Form.RefreshDeliveryMethods(result.Object.RawHtml);
                        mmsystem.plugins.ProductFilter.GetProductFilteredList().html(result.Object.RawHtml);
                        mmsystem.plugins.ProductFilter.UpdateProductFilterSelectedSections();
                        mmsystem.plugins.Basket.EventEmitter.emit('getProductListHtmlComplete', result);
                        //refresh js functionality
                        mmsystem.plugins.Pagination.AddEvenListeners();
                    }
                }

                mmsystem.plugins.AjaxCover.Hide();

            });
        },

        CheckIfRadioSingleOption: function (element) {
            
            if (element.is(":checked")) {
                // the name of the box is retrieved using the .attr() method
                // as it is assumed and expected to be immutable
                var group = "input:checkbox[data-group='" + element.data("group") + "']"; // "input:checkbox[name='" + element.attr("name") + "']";
                console.log(element.data("group"));
                console.log(group);
                // the checked state of the group/box on the other hand will change
                // and the current value is retrieved using .prop() method
                $(group).prop("checked", false);
                element.prop("checked", true);
            } else {
                element.prop("checked", false);
            }
        },

        GetFilteredProductList: function (extraData) {
            var data = mmsystem.plugins.ProductFilter.GetFilterData();
            if (extraData)
                $.extend(data, extraData);
            mmsystem.plugins.AjaxCover.ShowOnElement('productsSelection');
            mmsystem.ui.ajax.GetProductList(mmsystem.plugins.ProductFilter.Settings.GetProductListHtmlAPIUrl, data);
        },

        GetFilterData: function () {
            //console.log(mmsystem.plugins.ProductFilter.GetSelectedCategoryIdArray());
            //console.log(mmsystem.plugins.ProductFilter.GetSelectedPriceOrder());
            mmsystem.plugins.ProductFilter.SelectedCategoriesArray = mmsystem.plugins.ProductFilter.GetSelectedCategoryIdArray();
            mmsystem.plugins.ProductFilter.PriceOrder = mmsystem.plugins.ProductFilter.GetSelectedPriceOrder();
            var data = { Id: mmsystem.plugins.ProductFilter.Id, ProductTypeId: mmsystem.plugins.ProductFilter.ProductTypeId, ProductTagSelected: mmsystem.plugins.ProductFilter.SelectedCategoriesArray, PriceOrder: mmsystem.plugins.ProductFilter.PriceOrder };
            return data;
        },

        GetCategorySelectElements: function () {
            return $('.productTagFilter');
        },

        GetPriceSortSelectElements: function () {
            return $('.productPriceFilter');
        },

        GetProductFilteredList: function () {
            return $('#product-filtered-list');
        },

        GetProductFilteredSelectedNamesElement: function () {
            return $('.product-filtered-names-list');
        },

        GetProductFilteredSelectedHeroElement: function () {
            return $('.products__hero__content');
        },

        GetProductFilteredSelectedHeroSection: function () {
            return $('#productsHero');
        },

        GetProductFilteredSelectedNamesElementHtml: function () {
            var html = '<h2>';
            $.each(mmsystem.plugins.ProductFilter.GetSelectedCategoryNamesArray(), function (i, value) {
                html += '<i class="italic--sb">' + value + '</i>'
                if (value !== mmsystem.plugins.ProductFilter.GetSelectedCategoryNamesArray().pop())
                    html += '&nbsp; | &nbsp;';
            });

            html += '</h2>';
            
            return html;
        },

        GetProductFilteredSelectedMainNameElementHtml: function () {
            var html = '<h2>';
            $.each(mmsystem.plugins.ProductFilter.GetSelectedMainCategoryNamesArray(), function (i, value) {
                html += '<i class="italic--sb">' + value + '</i>'
                if (value !== mmsystem.plugins.ProductFilter.GetSelectedMainCategoryNamesArray().pop())
                    html += '&nbsp; | &nbsp;';
            });

            html += '</h2>';

            return html;
        },

        GetProductFilteredSelectedMainName: function () {
            var html = '';
            if (!mmsystem.plugins.ProductFilter.GetSelectedMainCategoryNamesArray().length)
                html = mmsystem.plugins.ProductFilter.GetProductFilteredSelectedHeroElement().find('.pre-title').data('default');

            $.each(mmsystem.plugins.ProductFilter.GetSelectedMainCategoryNamesArray(), function (i, value) {
                html += value;
                if (value !== mmsystem.plugins.ProductFilter.GetSelectedMainCategoryNamesArray().pop())
                    html += '&nbsp; | &nbsp;';
            });

            html += '';

            return html;
        },


        GetProductFilteredSelectedMainDescription: function () {
            var html = mmsystem.plugins.ProductFilter.GetProductFilteredSelectedHeroElement().find('.pre-description').data('default');;
            $.each(mmsystem.plugins.ProductFilter.GetSelectedMainCategoryDescriptionArray(), function (i, value) {
                if (i == 0)
                    html = value;
            });

            return html;
        },

        GetProductFilteredSelectedMainUrl: function () {
            var html = mmsystem.plugins.ProductFilter.GetProductFilteredSelectedHeroElement().find('.pre-title').data('default-url');
            $.each(mmsystem.plugins.ProductFilter.GetSelectedMainCategoryUrlArray(), function (i, value) {
                if (i == 0)
                    html = value;
            });

            return html;
        },

        UpdateProductFilterSelectedSections: function () {
            mmsystem.plugins.ProductFilter.GetProductFilteredSelectedNamesElement().html(mmsystem.plugins.ProductFilter.GetProductFilteredSelectedMainNameElementHtml()); //GetProductFilteredSelectedNameElementHtml()
            mmsystem.plugins.ProductFilter.GetProductFilteredSelectedHeroElement().find('.pre-title').html(mmsystem.plugins.ProductFilter.GetProductFilteredSelectedMainName);
            mmsystem.plugins.ProductFilter.GetProductFilteredSelectedHeroElement().find('.pre-description').html(mmsystem.plugins.ProductFilter.GetProductFilteredSelectedMainDescription);
            mmsystem.plugins.ProductFilter.GetProductFilteredSelectedHeroSection().css({
                'background': '#fff url("../../images/pages/products/' + mmsystem.plugins.ProductFilter.GetProductFilteredSelectedMainUrl() + '.jpg") center bottom no-repeat',
                'background-size': 'cover'
            });
        },

        GetSelectedPriceOrder: function () {
            var value = '';
            this.GetPriceSortSelectElements().each(function (i, item) {
                
                var isSelected = $(this).prop('checked');
                console.log($(this).prop('checked'));
                console.log($(this).val());
                if (isSelected)
                    value = $(this).val();
            });

            return value;
        },

        GetSelectedCategoryIdArray: function () {
            var array = [];
            this.GetCategorySelectElements().each(function (i, item) {
                var isSelected = $(this).prop('checked');
                var id = parseInt($(this).val());
                if (isSelected)
                    array.push(id);
            });

            return array;
        },

        GetSelectedMainCategoryIdArray: function () {
            var array = [];
            this.GetCategorySelectElements().each(function (i, item) {
                var isSelected = $(this).prop('checked');
                var isMain = $(this).data('is-main');
                var id = parseInt($(this).val());
                if (isSelected && isMain)
                    array.push(id);
            });

            return array;
        },

        GetSelectedCategoryNamesArray: function () {
            var array = [];
            this.GetCategorySelectElements().each(function (i, item) {
                var isSelected = $(this).prop('checked');
                var name = $(this).attr("name");
                if (isSelected)
                    array.push(name);
            });
            
            return array;
        },

        GetSelectedMainCategoryNamesArray: function () {
            var array = [];
            this.GetCategorySelectElements().each(function (i, item) {
                var isSelected = $(this).prop('checked');
                var isMain = $(this).data('is-main');
                var name = $(this).attr("name");
                if (isSelected && isMain)
                    array.push(name);
            });

            return array;
        },

        GetSelectedCategoryDescriptionArray: function () {
            var array = [];
            this.GetCategorySelectElements().each(function (i, item) {
                var isSelected = $(this).prop('checked');
                var desc = $(this).data("description");
                if (isSelected)
                    array.push(desc);
            });

            return array;
        },

        GetSelectedMainCategoryDescriptionArray: function () {
            var array = [];
            this.GetCategorySelectElements().each(function (i, item) {
                var isSelected = $(this).prop('checked');
                var isMain = $(this).data('is-main');
                var desc = $(this).data("description");
                if (isSelected && isMain)
                    array.push(desc);
            });

            return array;
        },

        GetSelectedCategoryUrlArray: function () {
            var array = [];
            this.GetCategorySelectElements().each(function (i, item) {
                var isSelected = $(this).prop('checked');
                var url = $(this).data("url");
                if (isSelected)
                    array.push(url);
            });

            return array;
        },

        GetSelectedMainCategoryUrlArray: function () {
            var array = [];
            this.GetCategorySelectElements().each(function (i, item) {
                var isSelected = $(this).prop('checked');
                var isMain = $(this).data('is-main');
                var url = $(this).data("url");
                if (isSelected && isMain)
                    array.push(url);
            });

            return array;
        },

        AddToSelectedCategoriesArray: function (id) {
            this.SelectedCategoriesArray.push(id);
            console.log(this.SelectedCategoriesArray);
        },

        AddArrayToSelectedCategoriesArray: function (idArray) {
            $.each(idArray, function (index, value) {
                this.SelectedCategoriesArray.push(value);
            });
            
            console.log(this.SelectedCategoriesArray);
        },
        RemoveFromSelectedCategoriesArray: function (id) {

            this.SelectedCategoriesArray = jQuery.grep(mmsystem.plugins.ProductFilter.SelectedCategoriesArray, function (arrayValue) {
                return arrayValue != id;
            });
            console.log(this.SelectedCategoriesArray);
        },
        RemoveArrayFromSelectedCategoriesArray: function (idArray) {

            $.each(idArray, function (index, value) {
                mmsystem.plugins.ProductFilter.SelectedCategoriesArray = jQuery.grep(mmsystem.plugins.ProductFilter.SelectedCategoriesArray, function (arrayValue) {
                    return arrayValue != value;
                });
            });
            
            console.log(this.SelectedCategoriesArray);
        }
    },

    AjaxCover: {

        Settings: {
            CoverContainerClass: "ajax-cover-container",
            CoverElementClass: "overlay--loading",
            CoverButtonClass: "overlay--btn"
        },

        Init: function (settings) {
            //console.log("mmsystem.plugins.Toast.Init...");
            if (settings) {
                this.Settings.CoverContainerClass = settings.CoverContainerClass;
                this.Settings.CoverElementClass = settings.CoverElementClass;
                this.Settings.CoverButtonClass = settings.CoverButtonClass;
            }
        },

        ShowOnButton: function (id) {
            this.GetAjaxCoverContainer(id).addClass('position-relative').append('<span class="' + this.Settings.CoverElementClass + ' ' + this.Settings.CoverButtonClass + '"></span>');
        },

        ShowOnElement: function (id) {
            this.GetAjaxCoverContainer(id).addClass('position-relative').append('<span class="' + this.Settings.CoverElementClass + '"></span>');
        },

        Hide: function (id) {
            this.GetAjaxCoverContainer(id).removeClass('position-relative').find('.' + this.Settings.CoverElementClass).remove();
        },

        GetAjaxCoverContainer: function (id) {
            if(id)
                return $('.' + this.Settings.CoverContainerClass + '#' + id);
            else
                return $('.' + this.Settings.CoverContainerClass);
        }
    }
};


//Node exports
module.exports = mmsystem.plugins;


// Hot Module Accept
if (module.hot) {
    module.hot.accept();
}